const $ = window.jQuery

const hostname =
  window.location.hostname === "localhost" ? "http://www.uni.gl" : ""

const reloadTable = (date) => {
  $.ajax({
    url: `?update=true`,
  }).done(function (data) {
    const basketBoxHtml = $(data).find(".basket--box").html()
    if (basketBoxHtml != null && basketBoxHtml.length > 0) {
      $(".basket--box").html(basketBoxHtml)
    }

    const menuItemBasketHtml = $(data).find(".menu-item--basket").html()
    if (menuItemBasketHtml != null && menuItemBasketHtml.length > 0) {
      $(".menu-item--basket").html(menuItemBasketHtml)
    }

    const basketHtml = $(data).find(".basket").html()
    if (basketHtml != null && basketHtml.length > 0) {
      $(".basket").html(basketHtml)
    }
  })
}

window.clearCart = () => {
  return $.ajax({
    type: "POST",
    url: `${hostname}/umbraco/surface/Webshop/ClearCurrentOrder`,
    data: {},
  })
}

$(() => {
  $(".basket")
    .parent()
    .on("click", "*[data-remove-cart-item]", (event) => {
      const $target = $(event.target)
      const id = $target.data("remove-cart-item")
      const options = $target.data("remove-cart-item-options")

      const formData = {
        productId: id,
        options: options,
      }

      $.ajax({
        type: "POST",
        url: `${hostname}/umbraco/surface/Webshop/RemoveProductFromCart/`,
        data: formData,
        success: () => {
          reloadTable()
        },
      }).fail((...args) => {
        // This should never happen
        console.error("Could not POST", ...args)
        window.alert("Error - please try again")
      })

      return false
    })
})

$(() => {
  $(".basket")
    .parent()
    .on("keypress", (event) => {
      const isEnter = event.which === 13
      if (isEnter) {
        $("input").blur()
        return false
      }
    })

  $(".basket")
    .parent()
    .on("change", "*[data-update-quantity]", (event) => {
      const $target = $(event.target)
      const id = $target.data("update-quantity")
      let newValue = $target.val()
      const options = $target.data("update-quantity-options")

      if (newValue == null || newValue <= 0) {
        newValue = 0
        $target.val(newValue)
      }

      const formData = {
        productId: id,
        quantity: newValue || 0,
        options: options || "",
      }

      $.ajax({
        type: "POST",
        url: `${hostname}/umbraco/surface/Webshop/SetProductQuantityInCart/`,
        data: formData,
        success: () => {
          reloadTable()
        },
      }).fail((...args) => {
        // This should never happen
        console.error("Could not POST", ...args)
        $target.val(undefined)
        window.alert("Error - please try again")
      })

      return false
    })
})

$(() => {
  const $forms = $("form[data-cart-action]")

  $('#conf-product #conf-form [name="options"]').change((e) => {
    const prices = $("#conf-form")
      .find('[name="options"]:checked, [name="options"] option:selected')
      .map((index, element) => $(element).data("price"))
      .toArray()
    const sum = prices.reduce((a, b) => a + b, 0)
    $(".details-price").text("kr. " + sum)

    if (prices.length > 0) {
      $(".submit-button").show()
    } else {
      $(".submit-button").hide()
    }
  })

  $forms.each((i, form) => {
    const $form = $(form)

    $form.on("submit", (e) => {
      if ($form.hasClass("validate") && !$form.valid()) {
        return // Only submit valid forms
      }

      const $cartIcon = $(".cart-icon")
      const $spinnerIcon = $(".spinner-icon")

      $cartIcon.stop().delay(100).hide(0)
      $spinnerIcon.stop().delay(100).show(0)

      // const formData = $form.serialize()
      let formData =
        "options=" +
        $("#conf-form")
          .find('[name="options"]:checked, [name="options"] option:selected')
          .map((index, element) => $(element).val())
          .toArray()
          .join()
      formData += "&quantity=" + $("#conf-form").find('[name="quantity"]').val()
      formData +=
        "&productId=" + $("#conf-form").find('[name="productId"]').val()

      $.ajax({
        type: "POST",
        url: $form.data("cart-action"),
        data: formData,
        success: () => {
          const cloneCurrentSlideImageAnimation = () => {
            const $slideshow = $(".viewer-main")
            const currentSlideIndex = $slideshow.slick("slickCurrentSlide")
            const $currentSlide = $slideshow.find(
              `.slick-slide:nth-child(${currentSlideIndex + 1})`
            )
            const $currentSlideImage = $currentSlide.find("img")
            const $currentSlideImageClone = $currentSlideImage.clone()

            const $menuItemBasket = $(".menu-item--basket")

            $currentSlideImageClone.css({
              position: "absolute",
              top: $currentSlideImage.offset().top,
              left: $currentSlideImage.offset().left,
              zIndex: 9999,
              width: $currentSlideImage.outerWidth(),
              height: $currentSlideImage.outerHeight(),
            })

            $currentSlideImageClone.appendTo("body")

            $currentSlideImageClone.animate(
              {
                top:
                  $menuItemBasket.offset().top +
                  $menuItemBasket.outerHeight() / 3,
                left:
                  $menuItemBasket.offset().left +
                  $menuItemBasket.outerWidth() / 2,
                width: 10,
                height: 10,
              },
              800,
              () => {
                $currentSlideImageClone.fadeOut().remove()
                reloadTable()
              }
            )
          }

          const $body = $("html, body")
          if ($body.outerWidth() <= 480) {
            $body.animate(
              {
                scrollTop: 0,
              },
              window.pageYOffset,
              () => {
                cloneCurrentSlideImageAnimation()
              }
            )
          } else {
            cloneCurrentSlideImageAnimation()
          }
        },
        complete: () => {
          $cartIcon.stop().show(0)
          $spinnerIcon.stop().hide(0)
        },
      }).fail(() => {
        // This should never happen
        window.alert("Error - please try again")
      })

      // Prevent default behaviour
      return false
    })
  })
})

$(() => {
  const $countrySelector = $("select.country-selector")

  $countrySelector.on("change", function () {
    const selected = this.value
    const $spinnerIcon = $(".spinner-icon")

    $spinnerIcon.delay(100).show(0)

    $.ajax({
      type: "POST",
      url: `${hostname}/umbraco/surface/Webshop/UpdateOrderRecipientInformationRegion/`,
      data: { region: selected },
      success: () => {
        reloadTable()
      },
      complete: () => {
        $spinnerIcon.stop().hide(0)
      },
    }).fail((...args) => {
      // This should never happen
      console.error("Could not POST", ...args)
      window.alert("Error - please try again")
    })
  })
  if ($(".has-conference-product").length > 0) {
    $("#delivery-area-wrapper").hide()
    let valueToSelect = $("#delivery-area-wrapper select option:first").val()
    if (valueToSelect === "" || valueToSelect === undefined) {
      valueToSelect = $("#delivery-area-wrapper select option:eq(1)").val()
    }
    $("#delivery-area-wrapper select")
      .val(valueToSelect)
      .trigger("chosen:updated")
      .change()
  }

  hideInvoicePayment()
  $("#InvoicePayment").change((event) => {
    const invoicePaymentActive = $(event.target).is(":checked")
    if (invoicePaymentActive) {
      showInvoicePayment()
    } else {
      hideInvoicePayment()
    }
  })

  $("#invoice-payment select").change((event) => {
    const currentCustomerType = $(event.target).val()

    switch (currentCustomerType) {
      case "Privatperson":
        showInvoicePaymentPrivatePerson()
        hideInvoicePaymentCompany()
        break
      case "Virksomhed":
        showInvoicePaymentCompany()
        hideInvoicePaymentPrivatePerson()
        break
    }
  })

  function showInvoicePayment() {
    $("#invoice-payment *[required]").removeClass("ignore")
    $("#invoice-payment").show()
    $("#invoice-payment select").change()
    $("#submit-button").text($("#submit-button").data("text-invoice-payment"))
  }

  function showInvoicePaymentCompany() {
    $("#company-org *[required]").removeClass("ignore")
    $("#company-org").show()
    $("#company-name-not-required-info").hide()
    $("#company-name-field").attr("required", true)
  }

  function showInvoicePaymentPrivatePerson() {
    $("#private-person *[required]").removeClass("ignore")
    $("#private-person").show()
  }

  function hideInvoicePayment() {
    $("#invoice-payment *[required]").addClass("ignore")
    $("#invoice-payment").hide()
    hideInvoicePaymentCompany()
    hideInvoicePaymentPrivatePerson()
    $("#submit-button").text($("#submit-button").data("text-online-payment"))
  }

  function hideInvoicePaymentCompany() {
    $("#company-org *[required]").addClass("ignore")
    $("#company-org").hide()
    $("#company-name-not-required-info").show()
    $("#company-name-field").attr("required", false)
  }

  function hideInvoicePaymentPrivatePerson() {
    $("#private-person *[required]").addClass("ignore")
    $("#private-person").hide()
  }
})
